import type { ReactNode } from "react";

export const AuthPageLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-bottom bg-no-repeat p-2 bg-[image:none] sm:bg-[url('/images/blurred-colors.jpg')] bg-white sm:bg-primary">
      {children}
    </div>
  );
};
